<template>
  <div class="block-dark" :style="styles"></div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'BlockDark',
    props: ['styles']
  })
</script>

<style scoped>
  .block-dark {
    background-color: var(--bs-body-bg);
  }
</style>
